import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import styled from 'styled-components';
import cl from 'classnames';

import { flexGap } from '@doltech/utils/lib/css-style';
import { isNotEmpty } from '@doltech/utils/lib/text';

import { colorsV2 } from '../../../figma/colors-v2';
import { ResponsiveTypography } from '../../../figma/Typography/v3/ResponsiveTypography';

const HintTag = styled.div`
  display: flex;

  padding: 2px 10px;
  background-color: ${colorsV2.neutral10};
  border-radius: 8px;
`;

const Hints = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${flexGap([8, 8])}
`;

const Container = styled.div`
  display: none;

  &.visible {
    display: block;
  }
`;

export const GapFillHints = (props: RenderElementProps) => {
  const { attributes, children, element } = props;
  const { visible, hints: originalHints } = element;
  const hints = originalHints.filter((hint) => isNotEmpty(hint.text));

  if (visible && hints?.length)

  return (
    <Container
      className={cl('gap-fill-hints', { visible: Boolean(visible && hints?.length) })}
      contentEditable={false}
      {...attributes}
    >
      <ResponsiveTypography.Paragraph variant="semi-bold/18-24" color="neutral180" mb="16px">
        {'💡 Gợi ý'}
      </ResponsiveTypography.Paragraph>
      <Hints>
        {hints.map(({ id, text }) => (
          <HintTag key={id}>
            <ResponsiveTypography.Paragraph variant="regular/16-28" color="neutral180">
              {text}
            </ResponsiveTypography.Paragraph>
          </HintTag>
        ))}
      </Hints>
      {children}
    </Container>
  );
};
